import React from 'react';
import { ContentLayout } from '../../layouts/MainFrame/ContentLayout';
import { Card, Grid, useMediaQuery, useTheme, Box } from '@mui/material';
import NavigationList from '../../new-navigation';

export const ControlPagesWrapper: React.FC<{
    children?: React.ReactNode;
    sidebarItems: any;
}> = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(1100));

    return (
        <ContentLayout>
            <Grid container spacing={2}>
                {!isMobile && (
                    <Grid item lg={2} md={3}>
                        <Card>
                            <Box padding={0.5}>
                                <NavigationList menu={props.sidebarItems} />
                            </Box>
                        </Card>
                    </Grid>
                )}

                <Grid item xs>
                    {props.children}
                </Grid>
            </Grid>
        </ContentLayout>
    );
};
